import React from "react";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import ValidatorSelectField from "@/src/components/FormFields/ValidatorSelectField";
import { isRequired, minStringLength } from "@/src/services/validationRules";
import ValidatorTextField from "@/src/components/FormFields/ValidatorTextField";
import FormLegend from "@/src/components/Form/Common/FormLegend/FormLegend";
import { translate } from "@/src/services/translations/translations";
import { useForm } from "@/src/provider/Form/FormProvider";
import { FormDataTypes } from "@/src/types/FormDataTypes";
import wizardStyle from "@/src/components/Form/wizardStyle";

type PersonProps = {
  path: string;
  headline?: string;
  fieldsAreRequired?: boolean;
  allowNoGender?: boolean;
};

const Person = ({ path, headline = "Wie heißen Sie?", fieldsAreRequired = true, allowNoGender = true }: PersonProps) => {
  const { values }: FormDataTypes = useForm();

  return (
    <>
      <Grid sx={wizardStyle.gridTopSpaced} size={12}>
        <FormLegend>{headline}</FormLegend>
      </Grid>
      <Grid size={12}>
        <ValidatorSelectField
          displayEmpty={allowNoGender}
          label={translate("person.gender.label", values)}
          name={`${path}.gender`}
          autoComplete="sex"
          validators={!allowNoGender && fieldsAreRequired ? [{ validator: isRequired, message: "Bitte geben Sie die Anrede an" }] : []}
          MenuProps={{ slotProps: { paper: { style: { maxHeight: 200 } } } }}
        >
          {allowNoGender && <MenuItem value={""}>Keine Anrede</MenuItem>}
          <MenuItem value={"female"}>Frau</MenuItem>
          <MenuItem value={"male"}>Herr</MenuItem>
        </ValidatorSelectField>
      </Grid>
      <Grid
        sx={wizardStyle.gridSpace}
        size={{
          xs: 12,
          sm: 6,
        }}
      >
        <ValidatorTextField
          name={`${path}.givenName`}
          label={translate("person.givenName.label", values)}
          autoComplete="given-name"
          validators={
            fieldsAreRequired
              ? [
                  { validator: isRequired, message: "Bitte geben Sie den Vornamen an" },
                  { validator: minStringLength, params: [2], message: "Bitte kontrollieren Sie Ihre Eingabe" },
                ]
              : []
          }
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          sm: 6,
        }}
      >
        <ValidatorTextField
          name={`${path}.familyName`}
          label={translate("person.familyName.label", values)}
          autoComplete="family-name"
          validators={
            fieldsAreRequired
              ? [
                  { validator: isRequired, message: "Bitte geben Sie den Nachnamen an" },
                  { validator: minStringLength, params: [2], message: "Bitte kontrollieren Sie Ihre Eingabe" },
                ]
              : []
          }
        />
      </Grid>
    </>
  );
};

export default Person;
